"use client";

import React from "react";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { SquareArrowOutUpRight } from "lucide-react";

interface GhostBtnProps {
    className?: string;
    translationKey: string;
    translationNamespace: string;
    fallbackText: string;
    labelOverride?: string;
    onClick?: () => void
    route: string,
    icon?: React.ReactNode
}

const GhostBtn: React.FC<GhostBtnProps> = ({
    className = "",
    translationNamespace,
    translationKey,
    fallbackText,
    labelOverride,
    route,
    icon,
    onClick
}) => {
    const t = useTranslations(translationNamespace);

    // Get translation with fallback
    let buttonText = labelOverride?.trim() || fallbackText;
    try {
        if (!labelOverride?.trim()) {
            const translated = t(translationKey);
            if (translated && !translated.startsWith(`${translationNamespace}.`)) {
                buttonText = translated;
            }
        }
    } catch (error) {
        // Use fallback if translation fails
        buttonText = fallbackText;
    }


    return (
        <Link
            href={route}
            className={`bg-transparent group border transition-all duration-300 
                border-[#767EF6] rounded-[18px] md:rounded-3xl inline-flex items-center gap-2 px-4 
                sm:px-6 md:px-8 py-2.5 sm:py-3 md:py-4 text-white w-fit hover:scale-105
                text-sm sm:text-base md:text-[18px] text-center font-semibold
                ${className}`}
            onClick={onClick}
        >
            {buttonText}
            {icon || <SquareArrowOutUpRight className="size-[18px] sm:size-[20px] group-hover:translate-x-1 transition-transform duration-300" />}
        </Link>
    );
};

export default GhostBtn;
